import React, { useEffect } from 'react';

interface SeoProps {
  title: string;
  description?: string;
  pathname?: string;
  keywords?: string[] | string;
}

const BASE_URL = 'https://www.hogardoradohouse.com';

const Seo: React.FC<SeoProps> = ({ title, description, pathname, keywords }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | Hogar Dorado House` : 'Hogar Dorado House';
    document.title = fullTitle;

    const setMeta = (name: string, content: string) => {
      if (!content) return;
      let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };

    const setPropertyMeta = (property: string, content: string) => {
      if (!content) return;
      let tag = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };

    const url = pathname ? `${BASE_URL}${pathname}` : BASE_URL;

    const keywordsContent = Array.isArray(keywords)
      ? keywords.join(', ')
      : keywords;

    if (keywordsContent) {
      setMeta('keywords', keywordsContent);
    }

    if (description) {
      setMeta('description', description);
      setPropertyMeta('og:description', description);
      setMeta('twitter:description', description);
    }

    setPropertyMeta('og:title', fullTitle);
    setPropertyMeta('og:url', url);
    setPropertyMeta('og:type', 'website');

    setMeta('twitter:title', fullTitle);
    setMeta('twitter:card', 'summary_large_image');
  }, [title, description, pathname, keywords]);

  return null;
};

export default Seo;
